import type { ArTrackingMode } from './types';
import { logArEvent } from './logger';

const loadedScripts = new Map<string, Promise<void>>();

const loadScript = (src: string) => {
    const absoluteSrc = new URL(src, window.location.origin).toString();
    const existing = loadedScripts.get(absoluteSrc);
    if (existing) {
        return existing;
    }

    const promise = new Promise<void>((resolve, reject) => {
        const script = document.querySelector<HTMLScriptElement>(`script[data-gastroflow-src="${absoluteSrc}"]`);
        if (script?.dataset.loaded === 'true') {
            resolve();
            return;
        }

        const nextScript = script || document.createElement('script');
        nextScript.src = absoluteSrc;
        nextScript.async = false;
        nextScript.dataset.gastroflowSrc = absoluteSrc;

        nextScript.onload = () => {
            nextScript.dataset.loaded = 'true';
            resolve();
        };
        nextScript.onerror = () => {
            loadedScripts.delete(absoluteSrc);
            reject(new Error(`Falha ao carregar script: ${absoluteSrc}`));
        };

        if (!script) {
            document.head.appendChild(nextScript);
        }
    });

    loadedScripts.set(absoluteSrc, promise);
    return promise;
};

export const loadArRuntime = async (mode: ArTrackingMode) => {
    logArEvent('info', 'runtime_load_start', { mode });
    await loadScript('/vendor/ar/aframe.min.js');

    if (mode === 'image-tracking') {
        await loadScript('/vendor/ar/mindar-image-aframe.prod.js');
        logArEvent('info', 'runtime_load_done', { mode, scripts: ['aframe', 'mindar-image-aframe'] });
        return;
    }

    await loadScript('/vendor/ar/aframe-ar.js');
    logArEvent('info', 'runtime_load_done', { mode, scripts: ['aframe', 'aframe-ar'] });
};

export const resetArRuntimeCacheForTests = () => {
    loadedScripts.clear();
};
